<template>
  <div ref="content" id="playWind" :style="{ height: playerHeight + 'px' }"></div>
</template>

<script>
export default {
  name: 'HKVideoPlayer',
  props: {
    playerHeight: {
      type: String,
      default: '400'
    }
  },
  data() {
    return {
      jsDecoder: null,
      iWind: 0, // 当前选中的窗口索引
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.initPlugin();
    })
  },
  beforeDestroy() {
    this.stop();
    this.destroyWorker();
  },
  methods: {
    initPlugin() {
      const width = this.$refs.content.clientWidth
      if (typeof JSPlugin === 'undefined') {
        console.error('JSPlugin is not defined. Make sure jsPlugin-1.2.0.min.js and polyfill2.js are loaded.');
        this.$emit('error', 'JSPlugin not loaded');
        return;
      }
      this.jsDecoder = new JSPlugin({
        szId: "playWind",
        iWidth: width || 400,
        iHeight: this.playerHeight,
        iMaxSplit: 2,
        iCurrentSplit: 1,
        szBasePath: "./static/hk/",
        oStyle: {
          border: "#343434",
          borderSelect: "red",
          background: "#4C4B4B"
        },
        bOnlySupportJSDecoder: true
      });

      this.jsDecoder.JS_SetWindowControlCallback({
        windowEventSelect: (iWndIndex) => {
          this.iWind = iWndIndex;
          console.log("Selected window index:", iWndIndex);
        },
        pluginErrorHandler: (iWndIndex, iErrorCode, oError) => {
          console.error("Plugin Error:", iWndIndex, iErrorCode, oError);
          this.$emit('error', {iWndIndex, iErrorCode, oError});
        },
        performanceLack: () => {
          console.warn("Lack of performance");
          this.$emit('warning', 'Lack of performance');
        }
      });
      console.log("JSPlugin initialized.");
    },

    destroyWorker() {
      if (this.jsDecoder) {
        this.jsDecoder.JS_DestroyWorker().then(() => {
          console.log("destroyWorker success");
        });
      }
    },

    /**
     * @public
     * 启动实时预览。
     * @param {string} accessUrl - 网关访问 URL
     * @param {string} username - 用户名
     * @param {string} password - 密码
     * @param {string} previewUrl - 实时预览 URL (RTSP stream URL)
     */
    start({accessUrl = 'wss://lis.00e.com:443', username = 'admin', password = 'lly88498807', previewUrl}) {
      if (!this.jsDecoder) {
        console.error("JSPlugin not ready.");
        return;
      }

      if (!accessUrl || !username || !password || !previewUrl) {
        const errMsg = "缺少启动实时预览所需的连接参数。";
        console.error(errMsg);
        this.$emit('live-start-fail', errMsg);
        return;
      }

      const auth = `${username}:${password}`;

      console.log(accessUrl, auth, previewUrl, 'accessUrl')

      this.jsDecoder.JS_Play(accessUrl, {
        playURL: previewUrl,
        auth: auth
      }, this.iWind).then(() => {
        console.log("realplay success");
        this.$emit('live-start-success');
      }, (e) => {
        console.log(e, 'e')
        const errorMessage = "realplay failed";
        console.error(errorMessage, e);
        this.$message.warning('设备连接异常，请刷新重试');
        this.$emit('live-start-fail', e);
      });
    },
    /**
     * @public
     * 停止实时预览或回放。
     */
    stop() {
      if (!this.jsDecoder) {
        console.error("JSPlugin not ready for stop.");
        return;
      }
      this.jsDecoder.JS_Stop(this.iWind).then(() => {
        console.log("stop success");
        this.$emit('live-stop-success');
      }, (e) => {
        const errorMessage = "stop failed";
        console.error(errorMessage, e);
        this.$emit('live-stop-fail', e);
      });
    },
    /**
     * @public
     * 截图。
     * @param {string} szType - 截图类型，默认为 JPEG
     */
    capturePicture(szType = 'JPEG') {
      this.jsDecoder.JS_CapturePicture(this.iWind, "img", szType).then(() => {
        console.log("CapturePicture success");
      }, function () {
        console.log("CapturePicture failed");
      });
    },
    /**
     * @public
     * 全屏。
     */
    fullScreenSingle () {
      this.jsDecoder.JS_FullScreenSingle(this.iWind);
    },
  }
};
</script>

<style>
.playWind {
  width: 100%;
}

.draw-window {
  border: none !important;
}
#playCanvas0 {
}
</style>



// WEBPACK FOOTER //
// src/components/HKVideoPlayer.vue